import { render } from "./EditSupplier.vue?vue&type=template&id=28b34f76&scoped=true"
import script from "./EditSupplier.vue?vue&type=script&lang=js"
export * from "./EditSupplier.vue?vue&type=script&lang=js"

import "./EditSupplier.vue?vue&type=style&index=0&id=28b34f76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b34f76"]])

export default __exports__